import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const TableRowColumn = _ref => {
  let {
    id = "",
    className = "",
    isLockIcon = false,
    columnIndex = 0,
    showOverflow = false,
    style = {},
    label = "",
    children = [],
    onCellClick = null
  } = _ref;
  const handleCellClick = event => {
    event.stopPropagation();
    if (onCellClick) {
      onCellClick(columnIndex, event);
    }
  };
  const tableRowColumnClass = cn("px-3 py-4 text-sm word-break truncate leading-5 regular-font max-w-xs app-components-table-row-column", {
    "overflow-inherit": showOverflow,
    "width-4": isLockIcon
  }, className);
  const newChildren = filterChildren(children);
  return /*#__PURE__*/_jsx("td", {
    id: id,
    className: tableRowColumnClass,
    role: "gridcell",
    onClick: handleCellClick,
    style: style,
    "data-label": label,
    children: newChildren
  });
};
TableRowColumn.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** children props for content inside */
  children: PropTypes.node,
  /** on cell click passed from the TableRow component */
  onCellClick: PropTypes.func,
  /** Label to display when responsiveCardStyle is activated */
  label: PropTypes.string,
  /** Column index passed from TableRow component */
  columnIndex: PropTypes.number,
  /** Data (in columns) to hide passed from TableRow component */
  secondaryDataList: PropTypes.array,
  /** Add this prop if you need to show overflow */
  showOverflow: PropTypes.bool,
  /** Boolean if is lock icon column */
  isLockIcon: PropTypes.bool
};
export default TableRowColumn;
//# sourceMappingURL=TableRowColumn.js.map